<script setup lang="ts">
// One figure in the detail panel's grid: a label, the value on one line and
// a second line for what qualifies it (the set value, the cores, the codec).
// The value never wraps (a long one is cut short, whole on hover) and the
// second line's room is always kept, so a grid row keeps its height and
// nothing below it moves as figures change.
defineProps<{ label: string; title?: string; full?: string }>()
</script>

<template>
    <div class="min-w-0" :title="title">
        <div class="truncate text-[11px] text-fg-3">{{ label }}</div>
        <div class="truncate font-mono text-[13px] whitespace-nowrap tabular-nums" :title="full"><slot /></div>
        <div class="h-4 truncate font-mono text-[11px] whitespace-nowrap text-fg-2 tabular-nums" :title="full">
            <slot name="sub" />
        </div>
    </div>
</template>
